/* VoltShades — keuzehulp
   Start ingeklapt als compacte balk. Na "Start": 3 meerkeuzevragen → advies.
   Elk antwoord geeft punten aan producten (data-score, sleutels = data-zb-key van de productblokken).
   Het advies wordt opgebouwd uit het productblok zelf (titel, foto, prijs), zodat er nergens
   dubbele teksten staan. Geen afhankelijkheden. */
(function () {
  'use strict';
  var quiz = document.querySelector('[data-zb-quiz]');
  if (!quiz) return;
  var section = quiz.closest('.vs-zb-keuze');
  var intro = quiz.querySelector('[data-intro]');
  var panel = quiz.querySelector('[data-panel]');
  var startBtn = quiz.querySelector('[data-start]');
  var steps = [].slice.call(quiz.querySelectorAll('.vs-zb-quiz__step'));
  var result = quiz.querySelector('[data-result]');
  var back = quiz.querySelector('[data-back]');
  var count = quiz.querySelector('[data-count]');
  var bars = [].slice.call(quiz.querySelectorAll('.vs-zb-quiz__progress span'));
  var answers = [];
  var current = 0;

  quiz.hidden = false;

  function cards() {
    return [].slice.call(section.querySelectorAll('.vs-zb-product[data-zb-key]'))
      .filter(function (c) { return c.getAttribute('data-zb-key') !== 'geen'; });
  }

  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; });
  }

  function text(el, sel) {
    var n = el.querySelector(sel);
    return n ? n.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function show(i, focus) {
    current = i;
    steps.forEach(function (s, n) { s.hidden = n !== i; });
    result.hidden = i < steps.length;
    back.hidden = i === 0 || i >= steps.length;
    bars.forEach(function (b, n) {
      b.classList.toggle('is-done', n < i || i >= steps.length);
      b.classList.toggle('is-now', n === i);
    });
    count.textContent = i < steps.length ? (i + 1) + '/' + steps.length : 'Advies';
    if (focus) {
      var el = i < steps.length ? steps[i].querySelector('.vs-zb-quiz__q') : result;
      if (el) el.focus({ preventScroll: true });
    }
  }

  function open() {
    intro.hidden = true;
    panel.hidden = false;
    startBtn.setAttribute('aria-expanded', 'true');
    show(0, true);
  }

  function reset() {
    answers = [];
    steps.forEach(function (s) { [].forEach.call(s.querySelectorAll('button'), function (b) { b.removeAttribute('aria-pressed'); }); });
    cards().forEach(function (c) { c.classList.remove('is-match'); var m = c.querySelector('.vs-zb-match'); if (m) m.remove(); });
  }

  function close() {
    reset();
    panel.hidden = true;
    intro.hidden = false;
    startBtn.setAttribute('aria-expanded', 'false');
    startBtn.focus({ preventScroll: true });
  }

  function score() {
    var totals = {};
    answers.forEach(function (a) {
      Object.keys(a.score).forEach(function (k) { totals[k] = (totals[k] || 0) + a.score[k]; });
    });
    var list = cards().map(function (c, idx) {
      var key = c.getAttribute('data-zb-key');
      return { card: c, key: key, pts: totals[key] || 0, idx: idx, soon: c.getAttribute('data-zb-state') === 'soon' };
    });
    // Gelijke stand: het product dat bij vraag 2 (belangrijkst) punten kreeg wint, daarna de volgorde op de pagina.
    var prio = answers[1] ? answers[1].score : {};
    list.sort(function (a, b) {
      return (b.pts - a.pts) || ((prio[b.key] || 0) - (prio[a.key] || 0)) || (a.idx - b.idx);
    });
    return list;
  }

  function finish() {
    var list = score();
    if (!list.length) return;
    var best = list[0];
    var alt = best.soon
      ? list.filter(function (x) { return !x.soon; })[0]
      : list.filter(function (x) { return x !== best && !x.soon && x.pts > 0; })[0];

    var c = best.card;
    var img = c.querySelector('.vs-zb-product__media img');
    var price = c.querySelector('.vs-zb-product__price-d .vs-zb-price strong') || c.querySelector('.vs-zb-price strong');
    var href = c.getAttribute('data-href');

    var html = '<div class="vs-zb-quiz__pick">';
    html += '<div class="vs-zb-quiz__thumb">' + (img ? '<img src="' + img.currentSrc + '" alt="" width="80" height="100">' : '') + '</div>';
    html += '<div class="vs-zb-quiz__pickbody">';
    html += '<p class="vs-zb-quiz__label">' + (best.soon ? 'Ons advies · binnenkort' : 'Ons advies') + '</p>';
    html += '<p class="vs-zb-quiz__name">' + esc(text(c, '.vs-zb-product__title')) + '</p>';
    if (!best.soon && price) html += '<p class="vs-zb-quiz__price">vanaf <strong>' + esc(price.textContent) + '</strong></p>';
    html += '</div></div>';
    html += '<div class="vs-zb-quiz__actions">';
    if (href && !best.soon) html += '<a class="vs-zb-btn vs-zb-btn--primary" href="' + href + '">Stel samen</a>';
    html += '<button type="button" class="vs-zb-btn vs-zb-btn--outline" data-goto="' + c.id + '">Bekijk details</button>';
    html += '</div>';
    if (alt) {
      html += '<button type="button" class="vs-zb-quiz__alt" data-goto="' + alt.card.id + '">' +
        (best.soon ? 'Nu al leverbaar: ' : 'Ook goed: ') + '<strong>' + esc(text(alt.card, '.vs-zb-product__title')) + '</strong></button>';
    }
    html += '<button type="button" class="vs-zb-quiz__restart" data-restart>Opnieuw</button>';
    result.innerHTML = html;

    cards().forEach(function (x) { x.classList.remove('is-match'); var m = x.querySelector('.vs-zb-match'); if (m) m.remove(); });
    c.classList.add('is-match');
    var badge = document.createElement('span');
    badge.className = 'vs-zb-match';
    badge.textContent = 'Past bij jou';
    c.querySelector('.vs-zb-product__head').prepend(badge);

    show(steps.length, true);
  }

  quiz.addEventListener('click', function (e) {
    if (e.target.closest('[data-start]')) { open(); return; }
    if (e.target.closest('[data-close]')) { close(); return; }

    var opt = e.target.closest('.vs-zb-quiz__options button');
    if (opt) {
      var pts = {};
      try { pts = JSON.parse(opt.getAttribute('data-score') || '{}'); } catch (err) { pts = {}; }
      answers[current] = { label: opt.getAttribute('data-label') || opt.textContent.trim(), score: pts };
      answers.length = current + 1;
      [].forEach.call(opt.parentNode.children, function (b) { b.setAttribute('aria-pressed', b === opt ? 'true' : 'false'); });
      if (current + 1 < steps.length) show(current + 1, true); else finish();
      return;
    }
    if (e.target.closest('[data-back]')) { show(Math.max(0, current - 1), true); return; }
    if (e.target.closest('[data-restart]')) { reset(); show(0, true); return; }

    var go = e.target.closest('[data-goto]');
    if (go) {
      var target = document.getElementById(go.getAttribute('data-goto'));
      if (target) {
        // Direct springen (betrouwbaar in elke browser), met ruimte voor de vaste header.
        var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo(0, Math.max(0, top));
        target.classList.remove('is-flash');
        void target.offsetWidth;
        target.classList.add('is-flash');
      }
    }
  });
})();
